




































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import actionPointsRepository from '../repository/actionPointsRepository';
import projectsRepository from '@/services/projectsRepository';
import cCard from '@/components/default/Card.vue';
import cPopup from '@/components/default/Popup.vue';
import cDatagrid from '@/components/default/Datagrid.vue';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { ActionPointStatus } from '../enums/actionPointStatus';
import { DataSourceLoadOptionsBase, ProjectsClient, GetAllProjectContactsQuery } from '@/data/web-api-client';

import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxItem, DxLabel } from 'devextreme-vue/form';
import moment from 'moment';
import { LoadOptions } from 'devextreme/data/load_options';
import { AxiosResponse } from 'axios';

@Component({
  components: {
    cCard,
    cDatagrid,
    cPopup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxItem,
    DxLabel,
  },
})
export default class ActionPointsOverview extends Vue {
  @Prop({ required: false })
  public projectId: any;

  showCreatePopup: boolean = false;
  saving: boolean = false;
  createModel: IActionPointCreateDto = {
    title: '',
    assignedSubcontractorId: '',
    reportedBy: '',
    category: '',
    internal: false,
    priority: 5,
    projectId: '',
  };
  datasource = new DataSource({
    store: new dxCustomStore({
      key: 'id',
      load: async (loadOptions) => {
        const result = await actionPointsRepository.lookup(loadOptions, this.projectId);
        return {
          data: result.data.data,
          totalCount: result.data.totalCount,
        };
      },
      byKey: async (val: any) => {
        return (await actionPointsRepository.getSingle(val)).data;
      },
    }),
    paginate: true,
  });

  selectedProjectIdForCreate = '';
  contacts: IProjectAssignedContactObject[] = [];
  projectsClient = new ProjectsClient(undefined, this.$axios);

  async mounted() {
    if (this.projectId && this.projectId !== '') {
      this.selectedProjectIdForCreate = this.projectId;

      try {
        await projectsRepository.getProjectContacts(this.projectId).then((res) => {
          this.contacts = res.data.map((d) => d.contact);
        });
      } catch (err) {
        notificationService.showAxiosError(err);
      }

      this.createModel.projectId = this.projectId;
    }
  }

  openDetails(e: any) {
    if (e.row && !e.row.isEditing && e.column && e.column.type !== 'buttons' && e.column.type !== 'selection') {
      this.$router.push({ path: `/actionpoints/${e.row.data.id}`, query: { checkProjectOnHold: this.projectId ? 'false' : 'true' } });
    }
  }

  refresh() {
    try {
      ((this.$refs.grid as cDatagrid).$refs.actionPointsTable as any).instance.refresh();
    } catch {
      // do nothing
    }
  }

  deleteRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        await actionPointsRepository.delete((e.data as any).id);
        notificationService.saved();
        self.refresh();
        resolve(true);
      } catch (err) {
        notificationService.failedToSave();
        resolve(true);
      }
    });
  }

  async create() {
    try {
      if (this.projectId) {
        this.createModel.projectId = this.projectId;
      }

      const result = await actionPointsRepository.create(this.createModel);
      this.refresh();
      notificationService.saved();
      this.showCreatePopup = false;
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  public onRowPrepared(e: any) {
    if (!e.data) {
      return;
    }

    if (e.data.status && e.data.status == 2) {
      e.rowElement.style.backgroundColor = '#00b216';

      return;
    }

    if (e.data.dueDate) {
      const format = 'YYYY-MM-DD';
      const dueDate = moment(new Date(e.data.dueDate)).format(format);
      const nowDate = moment().format(format);

      if (moment(dueDate).isSame(nowDate)) {
        e.rowElement.style.backgroundColor = '#ecac37';
      } else if (moment(dueDate).isBefore(nowDate)) {
        e.rowElement.style.backgroundColor = '#ff6347';
      }
    }
  }

  getContactsDataSource(onlySubcontractors: boolean) {
    return {
      key: 'id',
      paginate: true,
      pageSize: 20,
      load: async (loadOptions: LoadOptions) => {
        if (loadOptions.filter) {
          loadOptions.filter = undefined;
        }

        if (loadOptions.searchExpr && loadOptions.searchOperation && loadOptions.searchValue) {
          loadOptions.filter = [['displayName', loadOptions.searchOperation, loadOptions.searchValue], 'or', ['email', loadOptions.searchOperation, loadOptions.searchValue]];
        }

        const options = new DataSourceLoadOptionsBase(
          Object.assign({}, loadOptions, {
            stringToLower: true,
          })
        );

        const command = new GetAllProjectContactsQuery({
          projectId: this.projectId,
          options,
          onlySubcontractors,
        });

        const result = await this.projectsClient.getAllProjectContacts(command);

        return {
          data: result.data,
        };
      },
      byKey: (val: any) => {
        return val;
      },
    };
  }

  get contactsOptions() {
    return {
      dataSource: this.getContactsDataSource(false),
      byKey: (val: any) => {
        return val;
      },
      displayExpr: 'displayName',
      valueExpr: 'id',
      searchEnabled: true,
    };
  }

  get sliderOptions() {
    return {
      min: 1,
      max: 10,
      label: {
        format: (value: string) => value,
        position: 'bottom',
        visible: true,
      },
      tooltip: {
        enabled: true,
        showMode: 'onHover',
        position: 'bottom',
        format: (value: string) => value,
      },
    };
  }

  get userOptions() {
    const objects = this.$store.getters['employees/items'];
    return {
      items: objects,
      valueExpr: 'id',
      displayExpr: 'displayName',
      disabled: true,
      searchEnabled: true,
    };
  }

  get statusOptions() {
    const options = [
      { value: ActionPointStatus.Open, text: 'Open' },
      { value: ActionPointStatus.Send, text: 'Verstuurd' },
      { value: ActionPointStatus.Processed, text: 'Uitgevoerd' },
      { value: ActionPointStatus.Ignore, text: 'Negeren' },
      { value: ActionPointStatus.OnHold, text: 'On-hold' },
    ];

    return {
      items: options,
      displayExpr: 'text',
      valueExpr: 'value',
    };
  }

  get toolbarOptions() {
    return [
      {
        location: 'before',
        widget: 'dxButton',
        options: {
          icon: 'fas fa-plus',
          text: 'Toevoegen',
          stylingMode: 'outlined',
          type: 'success',
          onClick: () => {
            this.showCreatePopup = true;
          },
        },
      },
    ];
  }

  get subcontractorForTableOptions() {
    return {
      dataSource: this.getContactsDataSource(true),
      displayExpr: 'displayName',
      valueExpr: 'id',
      searchEnabled: true,
    };
  }

  get subcontractorOptions() {
    return {
      dataSource: this.contacts.filter((o) => o.type === 'Subcontractor'),
      displayExpr: 'displayName',
      valueExpr: 'id',
      searchEnabled: true,
    };
  }

  get categoryOptions() {
    const list = this.$store.getters['catalogs/list']('ActionPointsCategories');
    let items = [];
    if (list) {
      items = list.values;
    }

    return {
      items,
    };
  }

  get projectOptions() {
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          key: 'id',
          load: async (loadOptions: any) => {
            if (Array.isArray(loadOptions.filter) && loadOptions.filter.length > 1 && loadOptions.filter[0] === 'id') {
              return {
                data: [],
                totalCount: 0,
              };
            }
            if (loadOptions.searchExpr && loadOptions.searchValue && loadOptions.searchOperation) {
              loadOptions.filter = [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
            }

            const result = await projectsRepository.lookup(loadOptions);
            return {
              data: result.data.data,
              totalCount: result.data.totalCount,
            };
          },
          byKey: async (val: any) => {
            return projectsRepository.getSingle(val).then((result: any) => {
              return result.data;
            });
          },
        }),
        paginate: true,
      }),
      valueExpr: 'id',
      displayExpr: 'name',
      searchExpr: 'name',
      searchEnabled: true,
      onValueChanged: async (e: any) => {
        this.selectedProjectIdForCreate = e.value;
        await projectsRepository.getProjectContacts(this.selectedProjectIdForCreate).then((res: AxiosResponse<IProjectAssignedContact[]>) => {
          this.contacts = res.data.map((d) => d.contact);
        });
      },
    };
  }

  get columns() {
    return [
      {
        dataField: 'projectName',
        caption: 'Projectnaam',
      },
      {
        dataField: 'projectNumber',
        caption: 'Projectnummer',
      },
      {
        dataField: 'documentNumber',
        caption: 'Documentnr.',
      },
      {
        dataField: 'title',
        caption: 'Titel',
      },
      {
        dataField: 'status',
        caption: 'Status',
        lookup: this.statusOptions,
      },
      {
        dataField: 'priority',
        caption: 'Prioriteit',
        alignment: 'left',
      },
      {
        dataField: 'category',
        caption: 'Categorie',
      },
      {
        dataField: 'internal',
        caption: 'Intern',
        dataType: 'boolean',
      },
      {
        dataField: 'dueDate',
        caption: 'Opleverdatum',
        dataType: 'date',
      },
      {
        dataField: 'reportedBy',
        caption: 'Gemeld door',
        lookup: this.contactsOptions,
      },
      {
        dataField: 'assignedSubcontractorId',
        caption: 'Onderaannemer',
        lookup: this.subcontractorForTableOptions,
      },
      {
        dataField: 'createdOn',
        caption: 'aanmaakdatum',
        dataType: 'datetime',
      },
      {
        dataField: 'createdBy',
        caption: 'Aangemaakt door',
        lookup: this.userOptions,
      },
      {
        type: 'buttons',
        buttons: ['edit', 'delete'],
      },
    ];
  }
}
